/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Vision_QuoteInputs */



/**
* | output |
* | --- |
* | "“To provide customer satisfaction through safe, efficient and professionally unbiased marine consultancy across the globe.”" |
*
* @param {About_Vision_QuoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_vision_quote = /** @type {((inputs?: About_Vision_QuoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Vision_QuoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("“在全球范围内提供安全、高效、专业公正的海事咨询，让客户满意。”")
	return /** @type {LocalizedString} */ ("“To provide customer satisfaction through safe, efficient and professionally unbiased marine consultancy across the globe.”")
});